import { InjectionToken } from '@angular/core';

/** Folder name under the published feature package for map boundary assets (`ng-package.json`). */
export const CANVAS_MAP_ASSETS_PACKAGE_DIR = 'map-assets';

/**
 * Browser URL prefix for canvas map assets (icons, etc.).
 * @deprecated No longer used internally for boundary GeoJSON — use `CANVAS_BOUNDARY_GEOJSON_URL`
 * from `canvas-tokens` to supply the project-specific boundary file instead.
 */
export const CANVAS_MAP_ASSETS_BASE_URL = new InjectionToken<string>('CANVAS_MAP_ASSETS_BASE_URL', {
  providedIn: 'root',
  factory: () => '/assets/canvas-map',
});
